import { render, staticRenderFns } from "./SafetyTrainingHS.vue?vue&type=template&id=5bb01f80"
import script from "./SafetyTrainingHS.vue?vue&type=script&lang=js"
export * from "./SafetyTrainingHS.vue?vue&type=script&lang=js"
import style0 from "./SafetyTrainingHS.vue?vue&type=style&index=0&id=5bb01f80&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports